import React, { memo, useState } from "react";
import { Outlet } from "react-router-dom";
import styles from "./BpsAdminLayout.module.scss";
import BpsAdminSideMenu from "./components/BpsAdminSidemenu";
import BpsAdminHeader from "./components/BpsAdminHeader";

type Props = {};

/**
 * Chrome of the BPS admin portal. Mirrors the bills / solar-market layout but
 * stands on its own: one module, a static side menu, and none of the
 * bills-specific country selector, breadcrumb or customer bottom nav.
 */
const BpsAdminLayout: React.FC<Props> = memo((props: Props) => {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	function toggleMobileMenu() {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	}

	return (
		<div className={styles.container}>
			<BpsAdminSideMenu mobileMenuOpen={isMobileMenuOpen} onMobileMenuClick={toggleMobileMenu} />
			<div className={styles.contentContainer}>
				<BpsAdminHeader onMenuClick={toggleMobileMenu} />
				<div className={styles.content}>
					<Outlet />
				</div>
			</div>
		</div>
	);
});

export default BpsAdminLayout;
